import { Html } from "@react-three/drei";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "../../design_system/StyledComponents/components/Typography";
import "./FirstTimePopup.css";
import { setShowTutorialPopup } from "../../Actions/PopupAction";
import { popupData } from "./TutorialData";
import { Close } from "@mui/icons-material";
import { Button } from "../../design_system/StyledComponents/components/Button";
import { setUserStatus } from "../../Actions/ApplicationStateAction";

const TutorialPopupUI = () => {
  const { showTutorialPopup, tutorialPopupDismissable, tutorialPopupNumber } =
    useSelector((state) => state.PopupState);
  const [fadeIn, setFadeIn] = useState(false);
  const [timeLeft, setTimeLeft] = useState(11); // 10 seconds countdown
  const [progress, setProgress] = useState(0);
  const [showClose, setSetShowClose] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (showTutorialPopup) {
      setFadeIn(true);
    }
  }, [showTutorialPopup, tutorialPopupNumber]);

  useEffect(()=>{
    if(fadeIn){
      setTimeLeft(11);
      setProgress(0);
      setSetShowClose(false);
    }
  },[tutorialPopupNumber])

  useEffect(() => {
    if (timeLeft === 0 && fadeIn && tutorialPopupDismissable) {
      setSetShowClose(true);
    }

    const timerId = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
      setProgress((prev) => prev + 10);
    }, 1000);

    return () => clearInterval(timerId);
  }, [timeLeft]);

  const handleClose = (val = true) =>{
    dispatch(setShowTutorialPopup({
      showTutorialPopup: false,
      tutorialPopupType: "",
      customisedPosition: null,
      tutorialPopupDismissable: false
    }))
    if(val){
      window.GAEvent("DrawTool", "FirstTimePopup", "ButtonClicked", "Close");
    }
    if(tutorialPopupNumber === 13){
      dispatch(setUserStatus())
    }
  }

  const handleClick1 = () => {
    setFadeIn(false);
    window.GAEvent("DrawTool", "FirstTimePopup", "ButtonClicked", popupData[tutorialPopupNumber]?.buttonType);
        const type = popupData[tutorialPopupNumber + 1]?.className? "ui" : "canvas";
              dispatch(setShowTutorialPopup({
                  showTutorialPopup: true,
                  tutorialPopupType: type,
                  tutorialPopupNumber: tutorialPopupNumber + 1,
                  tutorialPopupDismissable: false
              }))
  }


  if (!tutorialPopupNumber) return null;

  return fadeIn ? (
    <div
      className={`first-time-popup-class ${popupData[tutorialPopupNumber].className}`}
    >
      <div className="first-time-popup-container">
        {showClose && (
          <div className="first-time-popup-close">
            <Close
              style={{ cursor: "pointer", color: "white" }}
              onClick={handleClose}
            />
          </div>
        )}
        <div className="first-time-popup-header">
          <Typography modifiers={["header6", "medium"]}>
            {popupData[tutorialPopupNumber].title}
          </Typography>
        </div>
        <div className="first-time-popup-body">
          <Typography modifiers={["subtitle"]}>
            {popupData[tutorialPopupNumber]?.description
              ? popupData[tutorialPopupNumber].description
              : null}
          </Typography>
        </div>
        <div className="first-time-popup-footer">
          <div className="first-time-popup-footer-order">
            {popupData[tutorialPopupNumber]?.order ? (
              <Typography modifiers={["subtitle2", "white"]}>{popupData[tutorialPopupNumber]?.order}</Typography>
            ) : null}
          </div>
          <div className="first-time-popup-footer-button">
            {popupData[tutorialPopupNumber]?.buttonText1 ? (
              <Button
                className="first-time-popup-button"
                modifiers={["white", "small"]}
                onClick={handleClick1}
              >
                <Typography modifiers={["subtitle2", "medium"]}>
                  {popupData[tutorialPopupNumber].buttonText1}
                </Typography>
              </Button>
            ) : null}
          </div>
        </div>
        {!showClose && tutorialPopupDismissable && <div className="timer-container">
          <div className="timer-progress" style={{ width: `${progress}%` }} />
        </div>}
      </div>
    </div>
  ) : null;
};

export default TutorialPopupUI;
